exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3F6Dxj69s-EOkxpzY456BI{display:inline-block;width:32%;margin-bottom:20px}._3F6Dxj69s-EOkxpzY456BI ._3JN11TH3tWD4R1B1VBuKJC{font-size:28px;font-weight:500;line-height:34px}._3F6Dxj69s-EOkxpzY456BI ._1K7tS4y3BhN_Ng4P6cjjrg{color:#bdbdbd}._3F6Dxj69s-EOkxpzY456BI ._3Hg4PPeg3xDXhVMd5ysIvf{font-size:15px;letter-spacing:0.3px;line-height:16px;margin:3px 0 0 0;color:#424242}._3F6Dxj69s-EOkxpzY456BI._22FWXP-0hkeyrbh-WPF29u{margin-bottom:0px}\n", ""]);

// Exports
exports.locals = {
	"DashedMetric": "_3F6Dxj69s-EOkxpzY456BI",
	"value": "_3JN11TH3tWD4R1B1VBuKJC",
	"emptyValue": "_1K7tS4y3BhN_Ng4P6cjjrg",
	"label": "_3Hg4PPeg3xDXhVMd5ysIvf",
	"noMargin": "_22FWXP-0hkeyrbh-WPF29u"
};